const recurringInput = {
  frequency: {
    title: 'Festlegen, wie sich diese Schicht im Laufe der Zeit wiederholt',
    values: {
      dontRepeat: 'Wiederholt sich nicht',
      day: 'Täglich',
      week: 'Wöchentlich',
      month: 'Monatlich',
    },
    labels: {
      day: 'Tag(e)',
      week: 'Woche(n)',
      month: 'Monat(e)',
    },
  },
  repeatEvery: 'Alle wiederholen',
  repeatOn: 'Wiederholen am',
  repeatOnNote: 'Bitte wählen Sie mindestens einen Tag aus',
  ends: 'Ende',
  endsOn: 'Endet am',
  endsLabels: {
    never: 'Endet nie',
    date: `Bis {{date}}`,
    times: 'Nach {{number}} Vorkommen',
  },
  windowNote: 'Vorerst werden nur die ersten {{count}} Schichten erstellt. Die übrigen werden im Laufe der Zeit automatisch von einem Hintergrundprozess generiert.',
  endsDateNote: 'Das gewählte Enddatum ist zu früh - es würden keine Schichten erstellt. Wählen Sie ein späteres Datum.',

  form: {
    month: 'Monat',
    day: 'Tag',
    week: 'Woche',
    year: 'Jahr',
    occurrences: 'Vorkommen',
    after: 'Nach',
    never: 'Niemals',
    on: 'An',
  },
};

export default recurringInput;
